import { FormattedMessage, useIntl } from "react-intl";
import { useParams } from "react-router-dom";

import { useGetQuotations } from "api/queries/quotes/useGetQuotations";
import Card from "components/v2/Card/Card";
import LoadingSkeleton from "components/atoms/LoadingSkeleton/LoadingSkeleton";
import NoQuotesSubmitted from "pages/common/ShipmentQuotesV2/components/NoQuotesSubmitted";
import QuotationList from "pages/common/ShipmentQuotesV2/components/QuotationList";
import QuotationBanners from "pages/common/ShipmentQuotesV2/components/QuotationBanners/QuotationBanners";

function QuotesTable() {
  const intl = useIntl();
  const { id } = useParams();

  const { data: quotationData, isLoading } = useGetQuotations({
    shipmentId: id!,
    options: {
      enabled: !!id,
    },
  });
  const quotations = quotationData?.quotations || [];

  return (
    <div>
      <Card borderRadius="md">
        <Card.Header
          title={intl.formatMessage({
            id: "general.quotes",
            defaultMessage: "Quotes",
          })}
          showBorder
        />
        {!isLoading && <QuotationBanners />}
        <div className="px-3xl">
          {isLoading ? (
            <LoadingSkeleton rows={1} />
          ) : quotations.length === 0 ? (
            <div className="py-3xl">
              <NoQuotesSubmitted>
                <p className="mt-xs text-tertiary">
                  <FormattedMessage
                    id="quote.noQuoteSubmitted.shipper.subtitle"
                    defaultMessage="When providers submit a quote, it will show up here"
                  />
                </p>
              </NoQuotesSubmitted>
            </div>
          ) : (
            <QuotationList quotations={quotations} />
          )}
        </div>
      </Card>
    </div>
  );
}

export default QuotesTable;
